import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {parseJwt} from "./parseToken"
import {logoutUser} from "../services/AuthServices"

class MenuRight extends Component {
    constructor(props) {
        super(props)

        this.state = {
            token: this.props.token
        }
    }

    render() {
        const {token} = this.state
        const FACTORY_API_URL = process.env.REACT_APP_ENVIRONMENT === 'production' ? 'https://factory.merchize.com' : 'https://f1-staging.merchize.com'
        const userInfo = !!token && parseJwt(token)
        const {roles} = userInfo
        const listRoles = !!roles && !!roles.length && roles.map(i=>i.name)

        return (
            <div className='Menu d-flex'>
                {!!listRoles && !!listRoles.length && listRoles.includes('Super Admin') &&
                    <a href={FACTORY_API_URL} className='nav-link' style={{ fontWeight: '700' }}>
                        FAC
                    </a>
                }
                <div className="MenuRight">
                    Xin chào, <span
                        className="UserName">{token && parseJwt(token).username}</span>
                    <span className="Logout"
                        onClick={() => logoutUser()}>Logout</span>
                </div>
            </div>
        )
    }
}

MenuRight.propTypes = {
    token: PropTypes.string
}

export default MenuRight
